<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="main-container-title-box-text">
        <span class="title-box-text"> СМС-уведомления </span>
      </div>
    </div>

    <div v-show="!loading">
      <div class="table-container">
        <v-data-table
          :headers="tableHeaders"
          :items="smsItems"
          :footer-props="{
            itemsPerPageOptions: [10, 25, 50],
            'items-per-page-text': '',
          }"
          class="elevation-0 main-table"
          :items-per-page="optionTable.itemsPerPage"
          :page="optionTable.page"
          :server-items-length="optionTable.serverItemsLength"
          @pagination="tableChange"
          ref="sortableTable"
          fixed-header
        >
          <template v-slot:body="props">
            <tbody>
              <tr v-for="(item, index) in props.items" :key="index">
                <td>{{ item.id }}</td>
                <td>
                  {{ item.title }}
                </td>
                <td>
                  {{ item.description }}
                </td>
                <td>
                  {{ item.contentType }}
                </td>
                <td>
                  <template v-if="item.items">
                    {{ item.items.sentCount }}
                  </template>
                </td>
                <td>
                  <template v-if="item.items">
                    {{ item.items.notSentCount }}
                  </template>
                </td>
                <td>
                  <template v-if="item.items">
                    {{ item.items.totalCount }}
                  </template>
                </td>
                <td>
                  <template v-if="item.items">
                    {{
                      Math.floor(
                        (item.items.sentCount / item.items.totalCount) * 100
                      )
                    }}
                  </template>
                </td>
                <td>
                  {{ item.contentId }}
                </td>
                <td>
                  <span v-if="item.isSend"> Да</span>
                  <span v-else>Нет</span>
                </td>
                <td>
                  {{ item.dateCreated | moment(" HH:mm DD.MM.YYYY ") }}
                </td>
                <td>
                  <v-icon @click="deleteSMS(item.id)" color="var(--app-red-1)"
                    >mdi-delete-outline</v-icon
                  >
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </div>
    <div v-show="loading" class="body-container-sms">
      <v-progress-circular
        indeterminate
        :width="4"
        :size="70"
        color="var(--app-dark-blue-1) "
      ></v-progress-circular>
    </div>
    <v-divider></v-divider>
  </div>
</template>
<script>
export default {
  data: () => ({
    showInfo: false,
    x: null,
    y: null,
    smsItems: [],
    search: "",
    loading: true,
    optionTable: {
      page: 1,
      itemsPerPage: 10,
      serverItemsLength: -1,
    },

    tableHeaders: [
      {
        text: "ID",
        sortable: false,
      },
      {
        text: "Заголовок",
        sortable: false,
      },
      {
        text: "Описание",
        sortable: false,
      },
      {
        text: "Тип sms",
        sortable: false,
      },
      {
        text: "Кол-во отправленных",
        sortable: false,
      },
      {
        text: "Кол-во не отправленных",
        sortable: false,
      },
      {
        text: "Общее кол-во",
        sortable: false,
      },
      {
        text: "Процент отправленных",
        sortable: false,
      },
      {
        text: "ID типа",
        sortable: false,
      },
      {
        text: "Отправленно",
        sortable: false,
      },
      {
        text: "Дата создания",
        sortable: false,
      },
      {
        text: "",
        sortable: false,
      },
    ],
  }),
  methods: {
    checkLocal() {
      const localOptionTable = JSON.parse(
        localStorage.getItem("smsOptionTable")
      );
      if (localOptionTable) {
        this.optionTable = localOptionTable;
      }
    },
    deleteSMS(id) {
      this.$axios
        .delete(this.$store.getters.apiAdminPanelV2 + "/sms", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            smsId: id,
          },
        })
        .then(() => {
          this.getSMS();
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    getSMS() {
        this.loading = true;
        this.$axios
          .post(
            this.$store.getters.apiNotifications + "/sms/list",
            {
              ...this.optionTable,
            },
            {
              headers: {
                "secret-key": this.$store.state.secretKeyCookie,
              },
            }
          )
          .then((res) => {
            this.optionTable = res.data.optionTable;
            this.smsItems = res.data.items;
            this.loading = false;
          })
          .catch((err) => {
            this.$store.commit("errorSet", true);
            this.$store.commit("errorTextSet", err);
          });
    },
    tableChange(data) {
      this.optionTable.page = data.page;
      this.optionTable.itemsPerPage = data.itemsPerPage;
      localStorage.setItem("smsOptionTable", JSON.stringify(this.optionTable));
      this.getSMS();
    },
  },
  created() {
    this.checkLocal();
    this.getSMS();
  },
};
</script>
<style lang="scss" scoped>
.body-container-sms {
  height: calc(100vh - 195px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-container {
  height: calc(100vh - 195px);

  .main-table {
    height: calc(100vh - 195px) !important;
    min-height: calc(100vh - 195px) !important;
    max-height: calc(100vh - 195px) !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
::v-deep .v-data-footer {
  margin-right: 0 !important;
}
</style>
